export default (str, sep = ',') =>
  typeof str === 'string' ? str.split(sep) : str
